/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Standard_DescriptionInputs */



/**
* | output |
* | --- |
* | "The complete oneAI platform with enterprise-grade controls, no addons required." |
*
* @param {Pricing_Standard_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_standard_description = /** @type {((inputs?: Pricing_Standard_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Standard_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die vollständige oneAI-Plattform mit Enterprise-Kontrollen, keine Zusatzpakete erforderlich.")
	return /** @type {LocalizedString} */ ("The complete oneAI platform with enterprise-grade controls, no addons required.")
});